/**
 * Created by Christof Sander on 14.12.2016.
 */

module.exports = {
	config: {
		registerSecret: 'privilegeInfo',
		registerType: 'component'
	},

	hooks: {
		attach: function($element, options){
			if(options.refresh && options.privilegeInfo){
				this.model.privilegeInfo = options.privilegeInfo;
				this.refresh();
			}
		}
	}
};
